import { styled } from '@mui/material/styles';
import JsBarcode from 'jsbarcode';
import { ComponentPropsWithoutRef, useEffect, useRef } from 'react';

type BarcodeProps = {
  content: string;
} & ComponentPropsWithoutRef<'svg'>;

const StyledSvg = styled('svg')(({ theme }) => ({
  width: '100%',
  height: 'auto',
  '& text': {
    fill: theme.palette.primary.main,
  },
}));

export const Barcode = ({ content, ...rest }: BarcodeProps) => {
  const svgRef = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    if (svgRef.current) {
      try {
        JsBarcode(svgRef.current, content, {
          width: 2,
          height: 100,
          marginLeft: 30,
          fontSize: 10,
          fontOptions: 'bold',
          marginRight: 30,
          textMargin: 8,
        });
      } catch {
        // Clear previously rendered barcode so invalid input does not leave stale content visible.
        svgRef.current.innerHTML = '';
      }
    }
  }, [content]);

  return <StyledSvg {...rest} ref={svgRef} />;
};
